module.exports = __webpack_public_path__ + "img/ico_5.7a0413a8.png";